module.exports = __webpack_public_path__ + "static/media/slide5.9dceba89.jpg";